import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link/Link';
import Attention from '../../assets/icons/attention.svg';
import Close from '../../assets/icons/close.svg';
import { withTranslation } from 'react-i18next';

const Alert = React.memo(({t, title, description, url, dismissable, onClose }) => {
  return (
    <div id="alert" className="alert" role="region">
      <div className="content-container wide">
        <div className="alert-text">
          <p>
            <Attention className="attention" />
            <strong>{title}</strong>
            <span>{description}</span>
          </p>
          {url && (
            <Link type="arrow" className="black" href={url}>
              Details
            </Link>
          )}
        </div>
        {dismissable && (
          <div>
            <button onClick={onClose}>
              {t('search_bar.close')} <Close />
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

Alert.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  dismissable: PropTypes.bool
};

Alert.defaultProps = {
  title: 'Onderhoud zaterdag 2 februari',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non augue suscipit.',
  url: '/detail',
};

export default withTranslation()(Alert);
